export default __webpack_public_path__ + "static/media/queen_of_diamonds2.91139054.png";